import type { UserDoc } from '../../shared/types/users';

export type SessionSlot = 'computador' | 'celular';

type NavLike = Pick<Navigator, 'userAgent'> & { userAgentData?: { mobile?: boolean } };

export function detectSlot(nav: NavLike): SessionSlot {
  if (nav.userAgentData?.mobile) return 'celular';
  return /Android|iPhone|iPad|iPod|Mobile/i.test(nav.userAgent) ? 'celular' : 'computador';
}

/**
 * true só se a vaga existe, é de OUTRA sessão (authTime diferente) e foi reivindicada
 * depois (ou junto) da minha, pelo relógio do SERVIDOR (claimedAt). Não dá pra usar
 * só auth_time: o reauth renova o meu e um login antigo (auth_time menor) pode assumir
 * a vaga. O snapshot velho logo após o meu takeover tem claimedAt MENOR que o meu -> false.
 */
export function isDisplaced(
  sessions: UserDoc['sessions'],
  slot: SessionSlot,
  me: { authTime: number; claimedAt: number } | null
): boolean {
  const claim = sessions?.[slot];
  if (!claim || !me || claim.authTime === me.authTime) return false;
  const ms = (claim.claimedAt as { toMillis?: () => number } | undefined)?.toMillis?.() ?? 0;
  return ms >= me.claimedAt;
}

/** Data `dd/MM HH:mm` em BRT. */
export function formatSince(ms: number): string {
  const p = new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(new Date(ms));
  const g = (t: string) => p.find((x) => x.type === t)?.value ?? '';
  return `${g('day')}/${g('month')} ${g('hour')}:${g('minute')}`;
}
